import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

const Header: React.FC = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  const [open, setOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleOptions = () => {
    setOpen((prev) => !prev);
  };

  return (
    <AppBar
      position="sticky"
      sx={{ backgroundColor: "#212d61", boxShadow: "none", zIndex: 1000 }}
    >
      <Container maxWidth="lg">
        <Toolbar
          sx={{
            justifyContent: "space-between",
            flexDirection: { xs: "row", md: "row" },
            alignItems: "center",
          }}
        >
          {/* Logo */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center" }}>
              <Box component="img" src="/logo_white_temp.png" alt="Logo" sx={{ width: 40, height: 40, mr: 1 }} />
              <Typography
                variant="h6"
                fontSize={{ xs: "1rem", md: "1.5rem" }}
                sx={{ color: "white", fontWeight: "bold" }}
              >
                Chương Trình Bảo Lãnh Sinh Viên Vay, Lãi Suất 0%
              </Typography>
            </Link>
          </Box>

          {/* Menu Desktop */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
            <Button
              component={Link}
              to="/"
              sx={{
                color: isActive("/") ? "white" : "white",
                fontSize: "1.1rem",
                "&:hover": { backgroundColor: "transparent", color: "white" },
              }}
            >
              Trang chủ
            </Button>

            <Box sx={{ position: 'relative', display: 'inline-block' }}>
              <Button
                onClick={toggleOptions}
                sx={{
                  color: 'white',
                  fontSize: '1.1rem',
                  '&:hover': { backgroundColor: 'transparent', color: 'white' },
                }}>
                Đóng góp
              </Button>

              {open && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    backgroundColor: 'white',
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                    borderRadius: '4px',
                    width: 'auto', // Automatically adjust to the content width
                    whiteSpace: 'nowrap', // Prevent text wrapping
                    zIndex: 2,
                  }}>
                  <Button
                    component={Link}
                    to="/dong-gop-ca-nhan"
                    sx={{ display: 'block', fontSize: '1rem', color: 'black', width: '100%', textAlign: 'left' }}
                    onClick={() => setOpen(false)}>
                    Cá nhân
                  </Button>
                  <Button
                    component={Link}
                    to="/dong-gop-doanh-nghiep"
                    sx={{ display: 'block', fontSize: '1rem', color: 'black', width: '100%', textAlign: 'left' }}
                    onClick={() => setOpen(false)}>
                    Doanh nghiệp
                  </Button>
                </Box>
              )}
            </Box>

            <Button
              component={Link}
              to="/lien-he"
              sx={{
                color: isActive("/lien-he") ? "white" : "white",
                fontSize: "1.1rem",
                "&:hover": { backgroundColor: "transparent", color: "white" },
              }}
            >
              Liên hệ
            </Button>
          </Box>

          {/* Menu Mobile (Hamburger) */}
          <IconButton
            sx={{ display: { xs: "block", md: "none" }, color: "black" }}
            onClick={() => setDrawerOpen(true)}
          >
            <MenuIcon />
          </IconButton>

          {/* Drawer (Mobile Menu) */}
          <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
            <List sx={{ width: 250 }}>
              <ListItem component={Link} to="/" onClick={() => setDrawerOpen(false)}>
                <ListItemText primary="Trang chủ" />
              </ListItem>
              <ListItem component={Link} to="/dong-gop-ca-nhan" onClick={() => setDrawerOpen(false)}>
                <ListItemText primary="Đóng góp Cá nhân" />
              </ListItem>
              <ListItem component={Link} to="/dong-gop-doanh-nghiep" onClick={() => setDrawerOpen(false)}>
                <ListItemText primary="Đóng góp Doanh nghiệp" />
              </ListItem>
              <ListItem component={Link} to="/lien-he" onClick={() => setDrawerOpen(false)}>
                <ListItemText primary="Liên hệ" />
              </ListItem>
            </List>
          </Drawer>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
